import { CardPaymentsStore as Store } from '@/src/experiences/card-payments/store'
import { BaseFundingSource } from '@/src/common/components/baseFundingSource'
import { usePaymentScreen } from '../hooks/usePaymentScreen'
import { CardPaymentsE2E } from '../e2e'
import { withPaymentMethodsForCardManagement } from '@/src/experiences/card-payments/providePaymentMethods/withPaymentMethodsForCardManagement'

export function useOnetimePaymentFundingSourceCardStackScreenProps() {
  return usePaymentScreen(
    'oneTimePayment/fundingSource',
    'Select Funding Source',
    '/main/card/card-management/payment/oneTimePayment',
  )
}

const OnetimePayFundingSource = withPaymentMethodsForCardManagement((paymentMethods) => {
  const { account, setAccount } = Store.useOneTimePayment()
  const { Modal, routerPush } = useOnetimePaymentFundingSourceCardStackScreenProps()

  return Modal({
    children: (
      <BaseFundingSource
        storedAccount={account}
        setStoredAccount={setAccount}
        pushToNextScreen={() =>
          routerPush('/main/(tabs)/card/card-management/payment/oneTimePayment/confirmation')
        }
        testID={CardPaymentsE2E.Ids.Press.Continue}
        paymentMethods={paymentMethods}
      />
    ),
  })
})

export const OnetimePayFundingSourceScreen = {
  name: 'auto-pay-schedule',
  Screen: OnetimePayFundingSource,
} as const
